export default {
    date:'تاریخ',
    weight: 'وزن',
    childGender: 'جنسیت',
    finding: 'تشخیص',
    commentAndComplications: 'نظر ',
    parityTypeId:'نوع زایمان',
}